import { render, staticRenderFns } from "./my-inquiry.vue?vue&type=template&id=4ad59eaa&scoped=true&"
import script from "./my-inquiry.vue?vue&type=script&lang=js&"
export * from "./my-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./my-inquiry.vue?vue&type=style&index=0&id=4ad59eaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad59eaa",
  null
  
)

export default component.exports